
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DataExtractionProgressSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataExtractionProgressSummary"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"needExtractionCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partiallyExtractedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conflictedExtractionCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extractedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requiresExtractionByUserCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userDraftCount"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":218}};
    doc.loc.source = {"body":"fragment DataExtractionProgressSummary on DataExtractionProgressSummary {\n  needExtractionCount\n  partiallyExtractedCount\n  conflictedExtractionCount\n  extractedCount\n  requiresExtractionByUserCount\n  userDraftCount\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
